import { combineEpics } from "redux-observable";
import { epicDisconnectedByLogin } from "./epicDisconnectedByLogin";
import { epicReconnectAfterLogin } from "./epicReconnectAfterLogin";
export var epicReconnect = combineEpics(epicDisconnectedByLogin, epicReconnectAfterLogin);



//////////////////
// WEBPACK FOOTER
// ./src/features/reconnect-after-login/epicReconnect.ts
// module id = 2123
// module chunks = 3